import { Alert, Box, Typography } from "@mui/material";
import { FC } from "react";

type ErrorAlertProps = {
  error: string;
  hideTitle?: boolean;
  fill?: boolean;
}

const ErrorAlert: FC<ErrorAlertProps> = ({ error, hideTitle=false, fill }): JSX.Element => {
  return Boolean(error) ? (
    <Box
      sx={{
        width: "100%",
      }}
    >
      <Alert
        severity="error"
        sx={{
          maxWidth: fill ? "100%" : "50%",
          margin: "auto",
        }}
      >
        {!hideTitle && (
          <Typography>
            Tivemos um problema para processar essa ação. Por favor entre em contato com o suporte do sistema e envie um print do erro abaixo.
          </Typography>
        )}

        <Typography>
          <strong>Erro: {error}</strong>
        </Typography>
      </Alert>
    </Box>
  ) : (
    <></>
  );
}

export default ErrorAlert;
